<template>
  <div id="tenders-wrap" class="service-wrap2 tenders-wrap2">
    <div class="row">
      <!-- Filters -->
      <div class="col-12 mb-3">
        <TenderFilters
          v-model="uiFilters"
          :assortments="assortments"
          :service-types="serviceTypes"
          :default-open="false"
          @apply="applyFilters"
        />
      </div>

      <!-- Loading / empty states -->
      <div v-if="loading" class="col-12">Kraunasi ...</div>
      <div v-else-if="!tenders.length" class="col-12">Konkursų nėra.</div>

      <!-- List -->
      <div v-else class="col-12">
        <div class="tenders-grid">
          <TenderCard
            v-for="t in tenders"
            :key="t.id"
            :tender="normalizeTender(t)"
          />
        </div>
      </div>

      <!-- Pagination -->
      <div v-if="pagination && 1 === 2" class="col-12">
        <nav class="d-flex justify-content-between align-items-center mt-2">
          <button
            class="btn btn-outline-secondary btn-sm"
            :disabled="pagination.current_page <= 1"
            @click="goTo(pagination.current_page - 1)"
          >
            « Atgal
          </button>
          <small class="text-muted">
            Puslapis {{ pagination.current_page }} iš
            {{ pagination.last_page }} — iš viso {{ pagination.total }}
          </small>
          <button
            class="btn btn-outline-secondary btn-sm"
            :disabled="pagination.current_page >= pagination.last_page"
            @click="goTo(pagination.current_page + 1)"
          >
            Pirmyn »
          </button>
        </nav>
      </div>
    </div>
  </div>
</template>

<script>
// If using Nuxt auto-imports, you can omit these imports.
// Otherwise adjust to your project structure.
// eslint-disable-next-line import/extensions
import TenderCard from './TenderCard.vue'
// eslint-disable-next-line import/extensions
import TenderFilters from './TenderFilters.vue'

export default {
  name: 'Tenders',
  components: { TenderCard, TenderFilters },

  data() {
    return {
      loadedOnce: false,
      uiFilters: { assortments: [], serviceTypes: [] }, // bound to filters component
    }
  },

  computed: {
    loading() {
      return this.$store.getters['tenders/loading']
    },
    tenders() {
      return this.$store.getters['tenders/list'] || []
    },
    assortments() {
      return this.$store.getters['tenders/assortments'] || []
    },
    serviceTypes() {
      return this.$store.getters['tenders/serviceTypes'] || []
    },
    pagination() {
      return this.$store.getters['tenders/pagination'] || null
    },
    storeFilters() {
      return this.$store.getters['tenders/filters']
    },
  },

  async mounted() {
    // Load filter options once
    await this.$store.dispatch('tenders/loadFilters')

    // Sync UI with store (in case store has persisted filters)
    this.uiFilters = {
      assortments: [...(this.storeFilters.assortments || [])],
      serviceTypes: [...(this.storeFilters.serviceTypes || [])],
    }

    // Initial fetch if list is empty
    if (!this.tenders.length) {
      await this.$store.dispatch('tenders/fetch', {})
    }
    this.loadedOnce = true
  },

  methods: {
    normalizeTender(t) {
      return {
        ...t,
        title: t.title || t.name || '',
        sub_title: t.sub_title || '',
        summary: t.summary || t.description || '',
        url: t.url || t.link || '#',
        assortments: t.assortments || [],
        service_types: t.service_types || t.serviceTypes || [],
        deadline: t.submissions_close_date || '',
      }
    },

    async applyFilters(payload) {
      // Update Vuex filters and fetch page 1
      this.$store.dispatch('tenders/updateFilters', {
        assortments: payload.assortments,
        serviceTypes: payload.serviceTypes,
      })
      await this.$store.dispatch('tenders/fetch', { page: 1 })
    },

    async goTo(page) {
      await this.$store.dispatch('tenders/goToPage', page)
      // scroll to top of list for better UX
      try {
        window.scrollTo({ top: 0, behavior: 'smooth' })
      } catch (e) {}
    },
  },
}
</script>
